import React, {useState,useEffect} from 'react'
import { useForm } from 'react-hook-form';
import axios from 'axios';

import { showAllWarehousesApi } from '../../../Utils/APIs/allWarehouseAPI';
import Select from 'react-select';
export const Consignment = () => {
    const [ allWarehouse, setShowAllWarehouses ] = useState([
      {
      "_id": "67446a8b27dae6f7f4d985dd",
      "warehouseName": "Bhiwani",
      "latitude": "28.912618",
      "longitude": "75.982816"
      },
      {
      "_id": "67446aae27dae6f7f4d985ed",
      "warehouseName": "Sirsa",
      "latitude": "29.664148",
      "longitude": "74.969792"
      },
      {
      "_id": "67446ab527dae6f7f4d985f1",
      "warehouseName": "Hisar",
      "latitude": "29.508942",
      "longitude": "75.877999"
      },
      {
      "_id": "6784efa0aea96b50ee091a8c",
      "warehouseName": "Korba Chhattisgarh",
      "latitude": "22.371798",
      "longitude": "82.741398"
      },
      {
      "_id": "690835908a80011de511b648",
      "warehouseName": "Maharashtra Warehouse - Badnapur",
      "latitude": "19.617028539483247",
      "longitude": "75.77788817573374"
      }
    ]); 
    useEffect(()=>{
    // externalDataFetch("http://88.222.214.93:5000/service-team/all-service-persons", setFieldEmpList);
    showAllWarehousesApi(setShowAllWarehouses);
  }, []);
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors, isSubmitting },
      } = useForm();

    // const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [selectedDestWarehouse, setSelectedDestWarehouse] = useState(null);
    const [ listOfAllVehicleIds, setListOfAllVehicleIds ] = useState([]);

    const destWarehouseId = watch('destinationWarehouse');

    const fetchAllVehicleIds = async () => {
      try {
        const sendRequest = await axios.get(`${process.env.REACT_APP_API_URL}/track/vehicleList`)
        const data = sendRequest.data.data;
        setListOfAllVehicleIds(data);
      } catch (error) {
        alert('Server Down Contact to Shiv');
      }
    }

    useEffect(() => {
        fetchAllVehicleIds();
    }, []);

// Force update destination latitude & longitude when warehouse changes
// useEffect(() => {
//     const wh = allWarehouse.find(w => w._id === destWarehouseId);
//     if (wh) {
//       setSelectedDestWarehouse(wh);
//       setValue('desLatitude', wh.latitude);
//       setValue('desLongitude', wh.longitude);
//   }

// }, [allWarehouse, setValue]);

      const handleWarehouseChange = (e) => {
        const selectedId = e.target.value;
        const warehouse = allWarehouse.find(w => w._id === selectedId);
        if (warehouse) {
          // setSelectedWarehouse(warehouse);
          setValue('srcLatitude', warehouse.latitude);
          setValue('srcLongitude', warehouse.longitude);
        }
      };
      const handleDestinationChange = (e) => {
        const id = e.target.value;
        setSelectedDestWarehouse(id);
          const wh = allWarehouse.find(w => w._id === id);
          if (wh) {
            setSelectedDestWarehouse(wh);
            setValue('desLatitude', wh.latitude);
            setValue('desLongitude', wh.longitude);
          }
      };

      const handleVehicleChange = (e) => {
        setValue('vehicleId', e.target.value);
      }
      
      const onSubmit = async (data) => {
        const formData = new FormData();
    
        // Append regular fields
        Object.keys(data).forEach((key) => {
          if (
            key !== 'invoice' &&
            key !== 'materialSheet' &&
            key !== 'challan' &&
            key !== 'e_bill'
          ) {
            formData.append(key, data[key]);
          }
        });
    
        // Append files
        if (data.invoice[0]) formData.append('invoice', data.invoice[0]);
        if (data.materialSheet[0]) formData.append('materialSheet', data.materialSheet[0]);
        if (data.challan[0]) formData.append('challan', data.challan[0]);
        if (data.e_bill[0]) formData.append('e_bill', data.e_bill[0]);
    
        try {
          await axios.post(`${process.env.REACT_APP_API_URL}/track/newConsignment`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          alert('Consignment submitted successfully!');
          reset();
          // setSelectedWarehouse(null);
          setSelectedDestWarehouse(null);
        } catch (err) {
          alert(err?.response?.data?.message || 'Error submitting consignment');
        }
      };
    return (
        <div className="w-full mx-auto p-6 mt-4 border rounded shadow">
          <h2 className="text-2xl font-bold mb-6 text-center">Add Consignment</h2>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
            encType="multipart/form-data"
          >
            {/* <div className="col-span-1">
              <label className="block font-semibold">Select Vehicle*</label>
              <select
                {...register('vehicleId', { required: true })}
                onChange={handleVehicleChange}
                className="w-full p-2 border rounded"
                defaultValue=""
              >
                <option value="" disabled>Select Vehicle</option>
                {listOfAllVehicleIds.map(({_id, vehicleNumber}, index ) => (
                  <option key={_id} value={_id}>{vehicleNumber}</option>
                ))}
              </select>
            </div> */}
            <div className="col-span-1">
  <label className="block font-semibold">Select Vehicle*</label>

  <Select
    options={listOfAllVehicleIds.map(item => ({
      value: item._id,
      label: item.vehicleNumber
    }))}
    placeholder="Select Vehicle"
    isSearchable
    onChange={(selected) => {
      setValue('vehicleId', selected.value);   // react-hook-form
      handleVehicleChange({ target: { value: selected.value } });
    }}
    className="mt-1"
  />

  <input type="hidden" {...register('vehicleId', { required: true })} />
</div>
            {/* Invoice */}
            <div>
                <label className="block font-semibold">Invoice (Image)*</label>
                <input
                    type="file"
                    accept="image/*"
                    {...register('invoice', { required: true })}
                    className="w-full p-2 border rounded"
                />
                {errors.invoice && <p className="text-red-600 text-sm">Invoice image is required</p>}
            </div>
    
            {/* Material Sheet */}
            <div>
                <label className="block font-semibold">Material Sheet (Image)</label>
                <input
                    type="file"
                    accept="image/*"
                    {...register('materialSheet')}
                    className="w-full p-2 border rounded"
                />
            </div>
    
            {/* Challan */}
            <div>
                <label className="block font-semibold">Challan (Image)*</label>
                <input
                    type="file"
                    accept="image/*"
                    {...register('challan', { required: true })}
                    className="w-full p-2 border rounded"
                />
                {errors.challan && <p className="text-red-600 text-sm">Challan image is required</p>}
            </div>
    
            {/* E-Bill */}
            <div>
                <label className="block font-semibold">E-Bill (Image)*</label>
                <input
                    type="file"
                    accept="image/*"
                    {...register('e_bill', { required: true })}
                    className="w-full p-2 border rounded"
                />
                {errors.e_bill && <p className="text-red-600 text-sm">E-Bill image is required</p>}
            </div>
    
            <div>
                <label className="block font-semibold">Select Source Warehouse*</label>
                <select
                    {...register('warehouseId', { required: 'Please select a warehouse' })}
                    onChange={handleWarehouseChange}
                    className="w-full p-2 border rounded"
                    defaultValue=""
                >
                    <option value="" disabled>Select Warehouse</option>
                    {allWarehouse.map(wh => (
                    <option key={wh._id} value={wh._id}>
                        {wh.warehouseName}
                    </option>
                    ))}
                </select>
                {errors.warehouseId && <p className="text-red-600 text-sm">{errors.warehouseId.message}</p>}
            </div>

            {/* Hidden Latitude & Longitude */}
            <input type="hidden" {...register('srcLatitude', { required: true })} />
            <input type="hidden" {...register('srcLongitude', { required: true })} />

            {/* Source Address */}
            <div>
              <label className="block font-semibold">Source Address</label>
              <input {...register('srcAddress')} className="w-full p-2 border rounded" />
            </div>
    
            {/* Destination Warehouse Dropdown */}
            {/* Destination Warehouse Dropdown */}
<div className="col-span-1">
  <label className="block font-semibold">Destination Warehouse*</label>
  <select
    {...register('destinationWarehouse', { required: true })}
    onChange={handleDestinationChange}
    className="w-full p-2 border rounded"
    defaultValue=""
  >
    <option value="" disabled>Select Destination</option>
    {allWarehouse.map(wh => (
      <option key={wh._id} value={wh._id}>{wh.warehouseName}</option>
    ))}
    <option value="Other">Other</option>
  </select>
</div>

{/* If destination is "other", show manual inputs */}
{selectedDestWarehouse === "Other" ? (
  <>
    <div className="col-span-1">
      <label className="block font-semibold">Destination Latitude*</label>
      <input
        {...register('desLatitude', { required: true })}
        className="w-full p-2 border rounded"
        placeholder="Enter destination latitude"
      />
      {errors.desLatitude && <p className="text-red-600 text-sm">Destination Latitude is required</p>}
    </div>

    <div className="col-span-1">
      <label className="block font-semibold">Destination Longitude*</label>
      <input
        {...register('desLongitude', { required: true })}
        className="w-full p-2 border rounded"
        placeholder="Enter destination longitude"
      />
      {errors.desLongitude && <p className="text-red-600 text-sm">Destination Longitude is required</p>}
    </div>
  </>
) : (
  <>
    {/* Hidden inputs when warehouse is selected */}
    <input type="hidden" {...register('desLatitude', { required: true })} />
    <input type="hidden" {...register('desLongitude', { required: true })} />
  </>
)}

            {/* Delivery Pincode */}
            <div>
              <label className="block font-semibold">Delivery Pincode</label>
              <input type="number" {...register('deliveryPincode')} className="w-full p-2 border rounded" />
            </div>
    
            {/* Delivery Address */}
            <div>
              <label className="block font-semibold">Delivery Address*</label>
              <input
                {...register('deliveryAddress', { required: 'Delivery Address is required' })}
                className="w-full p-2 border rounded"
              />
              {errors.deliveryAddress && <p className="text-red-600 text-sm">{errors.deliveryAddress.message}</p>}
            </div>
    
            {/* Submit Button - spans full width */}
            <div className="col-span-full">
            <button
                type="submit"
                className="tracking-widest text-dark bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full  py-2.5 text-center"
                >
                { isSubmitting ? 'Loading...' : 'Register' }
            </button>
            </div>
          </form>
          {destWarehouseId === 'other' && watch('desLatitude') && watch('desLongitude') && (
            <p className="text-sm text-gray-600 col-span-full">
                Destination Location (Manual): <strong>Lat:</strong> {watch('desLatitude')}, <strong>Lng:</strong> {watch('desLongitude')}
            </p>
            )}


        </div>
      );
}
